var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-user-avatar"},[(_vm.newUserAvatar)?_c('img',{attrs:{"src":_vm.newUserAvatar,"alt":_vm.userName}}):_c('b-icon',{staticClass:"header-icon",attrs:{"icon":"account-circle-outline","size":"is-medium"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }